import React, { FC } from "react";
import { FieldValues } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { NumberInput, useMuiController } from "@sinch/components/index";

export const DailyOvertimeSettings: FC<{ disabled?: boolean; path?: string }> = ({ disabled, path = "settings" }) => {
  const { t } = useTranslation();
  const { field } = useMuiController<FieldValues, string>({ name: `${path}.limit`, disabled });
  return <NumberInput {...field} fullWidth label={t("RateUnit.dailyOvertimeLimit")} min={0} />;
};
